import { LinkBreakIcon } from '@phosphor-icons/react';

import { Sizes } from '../constants/size';
import type { IconProps } from '../types/icon-props';

export const Unlink = (props: IconProps) => {
  const { size = 'md', fill = '#9696a0', ...rest } = props;

  return <LinkBreakIcon size={Sizes[size]} {...rest} color={fill} />;
};

Unlink.displayName = 'Unlink';
